'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
    [
      '\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ',
      ';\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: ',
      ' box-shadow;\n  box-shadow: 0 2px 4px ',
      ';\n  border-radius: ',
      ';\n  border-width: 0;\n  border-style: solid;\n\n  ',
      ';\n\n  &:hover, &:focus {\n    outline: 0;\n    box-shadow: 0 2px 6px ',
      ';\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 2px 8px 2px ',
      ';\n  }\n\n  ',
      ';\n\n  ',
      ';\n\n  ',
      ';\n  ',
      ';\n'
    ],
    [
      '\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  vertical-align: middle;\n  text-align: center;\n  text-decoration: none;\n  font-family: inherit;\n  font-weight: ',
      ';\n  line-height: 1.125;\n  appearance: none;\n  cursor: pointer;\n  transition: ',
      ' box-shadow;\n  box-shadow: 0 2px 4px ',
      ';\n  border-radius: ',
      ';\n  border-width: 0;\n  border-style: solid;\n\n  ',
      ';\n\n  &:hover, &:focus {\n    outline: 0;\n    box-shadow: 0 2px 6px ',
      ';\n  }\n\n  &:active {\n    outline: 0;\n    box-shadow: 0 2px 8px 2px ',
      ';\n  }\n\n  ',
      ';\n\n  ',
      ';\n\n  ',
      ';\n  ',
      ';\n'
    ]
  ),
  _templateObject2 = _taggedTemplateLiteral(
    [
      '\n      transition: ',
      ' all;\n      will-change: transform;\n      transform: scale(1);\n      &:hover,\n      &:focus {\n        transform: scale(',
      ');\n      }\n      ',
      ' {\n        transform: none !important;\n      }\n    '
    ],
    [
      '\n      transition: ',
      ' all;\n      will-change: transform;\n      transform: scale(1);\n      &:hover,\n      &:focus {\n        transform: scale(',
      ');\n      }\n      ',
      ' {\n        transform: none !important;\n      }\n    '
    ]
  ),
  _templateObject3 = _taggedTemplateLiteral(
    ["\n      &:before {\n        content: '\xAB ';\n      }\n    "],
    ["\n      &:before {\n        content: '\xAB ';\n      }\n    "]
  ),
  _templateObject4 = _taggedTemplateLiteral(
    ["\n      &:after {\n        content: ' \xBB';\n      }\n    "],
    ["\n      &:after {\n        content: ' \xBB';\n      }\n    "]
  )

var _styledComponents = require('styled-components')

var _styledComponents2 = _interopRequireDefault(_styledComponents)

var _propTypes = require('prop-types')

var _propTypes2 = _interopRequireDefault(_propTypes)

var _Box = require('./Box')

var _Box2 = _interopRequireDefault(_Box)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var Button = _Box2.default.withComponent('a').extend(
  _templateObject,
  function(props) {
    return props.theme.bold
  },
  function(props) {
    return props.theme.transition
  },
  function(props) {
    return props.theme.shadowColor
  },
  function(props) {
    return props.theme.pill
  },
  function(props) {
    return (
      props.inverted && {
        backgroundColor: (0, _theme.cx)(props.color),
        color: (0, _theme.cx)(props.bg)
      }
    )
  },
  function(props) {
    return props.inverted
      ? props.theme.shadowColor
      : (0, _theme.hexa)(props.bg, 0.25)
  },
  function(props) {
    return props.inverted
      ? props.theme.shadowColor
      : (0, _theme.hexa)(props.bg, 0.25)
  },
  function(props) {
    return props.disabled && { opacity: 0.25, cursor: 'not-allowed' }
  },
  function(props) {
    return (
      props.scale &&
      (0, _styledComponents.css)(
        _templateObject2,
        function(props) {
          return props.theme.transition
        },
        function(props) {
          return props.theme.scaleFactor
        },
        function(props) {
          return props.theme.mediaQueries.reduceMotion
        }
      )
    )
  },
  function(props) {
    return props.chevronLeft && (0, _styledComponents.css)(_templateObject3)
  },
  function(props) {
    return props.chevronRight && (0, _styledComponents.css)(_templateObject4)
  }
)

Button.displayName = 'Button'

Button.propTypes = {
  /** flip colors */
  inverted: _propTypes2.default.bool,
  /** add hover/focus animation */
  scale: _propTypes2.default.bool,
  /** add left text arrows */
  chevronLeft: _propTypes2.default.bool,
  /** add right text arrows */
  chevronRight: _propTypes2.default.bool
}

Button.defaultProps = {
  theme: _theme2.default,
  bg: 'primary',
  color: 'white',
  f: 3,
  m: 0,
  px: 3,
  py: 2
}

Button.button = Button.withComponent('button')
Button.input = Button.withComponent('input')

exports.default = Button



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/Button.js
// module id = 138
// module chunks = 168707334958949